import { BackgroundImage } from 'platform-components';
import React from 'react';

import './spec-course-lesson-view__banner.scss';

interface Props {
    src: string | null;
}

export const SpecCourseLessonViewBanner = React.memo(({ src }: Props) => {
    if (!src) {
        return <div className="lesson-passport__skeleton-item lesson-passport__skeleton-image" />;
    }

    return (
        <BackgroundImage.Container mix="spec-course-lesson-view__banner">
            <BackgroundImage objectFit="cover" src={src} />
        </BackgroundImage.Container>
    );
});
